import { h } from 'preact'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { SelectIcon } from '../../../assets/dynamicIcons/SelectIcon'
import { useTranslations } from '../../../hooks/useTranslations'
import './styles.scss'

const SelectBox = ({
  label,
  selectProps,
  options = [],
  testIdForOptions = 'select-box-option',
  className,
  hasError,
  errorMessage,
}) => {
  const l10n = useTranslations()

  const inputClasses = classNames([
    {
      error: hasError,
    },
    'input',
    'input-select',
    className,
  ])

  return (
    <div className={inputClasses}>
      <div className="label">{label}</div>
      <div className="group">
        <select {...selectProps}>
          <option value="" disabled selected hidden>{l10n.t('Select date')}</option>
          <option value=""></option>
          {options?.map(({ value, name }) => (
            <option data-testid={testIdForOptions} value={value}>
              {name}
            </option>
          ))}
        </select>
        <label
          aria-label={`${l10n.t('Control for: ')} ${label}`}
          className="icon-control"
          htmlFor={selectProps.id}
        >
          <SelectIcon />
        </label>
      </div>
      {hasError && (
          <p className="message" data-testid="error-message">
          {errorMessage}
        </p>
      )}
    </div>
  )
}

SelectBox.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  selectProps: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  testIdForOptions: PropTypes.string,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
}

export default SelectBox
